import { nodeApiClient } from './apiClient';

nodeApiClient.interceptors.request.use(
  (config) => {
    const username = localStorage.getItem("ncd_username");

    config.headers = config.headers || {};

    if (username) {
      config.headers.username = username;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const ncdAPI = {
  getHealthIdMapping: async (abhaNumber) => {
    try {
      const response = await nodeApiClient.get(`/ncd/healthid-mapping/${abhaNumber}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return { success: false, message: "Health ID not found" };
      }
      throw error;
    }
  },
  getScreenDetails: async (individualId) => (await nodeApiClient.get(`/ncd/screen-details/${individualId}`)).data,
  getPersonalExamination: async (individualId) => (await nodeApiClient.get(`/ncd/personal-examination/${individualId}`)).data,
  getPersonalHistory: async (individualId) => (await nodeApiClient.get(`/ncd/personal-history/${individualId}`)).data,
  getMenstrualHistory: async (individualId) => (await nodeApiClient.get(`/ncd/menstrual-history/${individualId}`)).data,
  getScreeningData: async (conditionId, individualId, screeningId) => (await nodeApiClient.get(`/ncd/screening-data/${conditionId}/${individualId}/${screeningId}`)).data,
  getVitalsHistory: async (individualId) => (await nodeApiClient.get(`/ncd/vitals-history/${individualId}`)).data,
  getLeftPanel: async (individualId) => (await nodeApiClient.get(`/ncd/left-panel/${individualId}`)).data,
  getCurrentMedications: async (individualId) => (await nodeApiClient.get(`/ncd/current-medications/${individualId}`)).data,
  getFollowupMedicines: async (conditionId) => (await nodeApiClient.get(`/ncd/followup-medicines/${conditionId}`)).data,
  submitHtn: async (formType, individualId, data) => {
    try {
      const response = await nodeApiClient.post(`/ncd/submit-htn/${formType}/${individualId}`, data);
      return response.data;
    } catch (error) {
      console.error('submitHtn error:', error);
      throw error;
    }
  },
  submitDb: async (formType, individualId, data) => {
    try {
      const response = await nodeApiClient.post(`/ncd/submit-db/${formType}/${individualId}`, data);
      return response.data;
    } catch (error) {
      console.error('submitDb error:', error);
      throw error;
    }
  },
  submitPersonalExam: async (data, individualId) => {
    try {
      const response = await nodeApiClient.post(`/ncd/submit-personal-exam/${individualId}`, data);
      return response.data;
    } catch (error) {
      console.error('submitPersonalExam error:', error);
      throw error;
    }
  },
  submitPersonalHistory: async (individualId, data) => {
    try {
      const response = await nodeApiClient.post(`/ncd/submit-personal-history/${individualId}`, data);
      return response.data;
    } catch (error) {
      console.error('submitPersonalHistory error:', error);
      throw error;
    }
  },
  submitMenstrualHistory: async (individualId, data) => (await nodeApiClient.post(`/ncd/submit-menstrual-history/${individualId}`, data)).data,
  submitTeleconsultation: async (individualId, data) => (await nodeApiClient.post(`/ncd/submit-teleconsultation/${individualId}`, data)).data,
  uploadTeleconsultationFile: async (individualId, data) => (await nodeApiClient.post(`/ncd/submit-teleconsultation-file/${individualId}`, data)).data,
  submitTeleconsultationDB: async (individualId, data) => (await nodeApiClient.post(`/ncd/submit-teleconsultation-db/${individualId}`, data)).data,
  submitCbac: async (data, individualId) => {
    try {
      const response = await nodeApiClient.post(`/ncd/submit-cbac/${individualId}`, { ...data, individualId });
      return response.data;
    } catch (error) {
      console.error('submitCbac error:', error);
      throw error;
    }
  },
  getCbacDetail: async (individualId) => (await nodeApiClient.get(`/ncd/cbac-detail/${individualId}`)).data,
  getVillages: async (facility) => (await nodeApiClient.get(`/ncd/villages/${facility}`)).data,
  getSubcenterUsers: async (facility) => (await nodeApiClient.get(`/ncd/subcenter-users/${facility}`)).data,
  getVillageData: async (facility, villageId) => (await nodeApiClient.get(`/ncd/village-data/${facility}/${villageId}`)).data,
  registerFamily: async (data) => (await nodeApiClient.post('/ncd/family-registration', data)).data,

  addFamilyMember: async (data, familyId) => {
    try {
      const response = await nodeApiClient.post(`/ncd/add-member/${familyId}`, { ...data, familyId });
      return response.data;
    } catch (error) {
      console.error('Add member error:', error);
      throw error;
    }
  },

  linkAbhaNcd: async (individualId, data) => (await nodeApiClient.post(`/ncd/link-abha-ncd/${individualId}`, data)).data,
  searchBeneficiary: async (data) => {
    const response = await nodeApiClient.post('/ncd/search-beneficiary', data);
    return response.data.data.searchRecords;
  },
  submitOralScreeningCHO: async (individualId, data) => (await nodeApiClient.post(`/ncd/oral-screening-cho/${individualId}`, data)).data,
  getOralScreeningCHO: async (individualId, screeningId) => (await nodeApiClient.get(`/ncd/oral-screening-cho/${individualId}/${screeningId}`)).data,
  submitOralScreening: async (individualId, screeningId, data) => (await nodeApiClient.post(`/ncd/oral-screening/${individualId}/${screeningId}`, data)).data,
  getOralScreening: async (individualId, screeningId) => (await nodeApiClient.get(`/ncd/oral-screening/${individualId}/${screeningId}`)).data,
  submitBreastScreening: async (individualId, screeningId, data) => (await nodeApiClient.post(`/ncd/breast-screening/${individualId}/${screeningId}`, data)).data,
  getBreastScreening: async (individualId, screeningId) => (await nodeApiClient.get(`/ncd/breast-screening/${individualId}/${screeningId}`)).data,
  submitBreastScreeningCHO: async (individualId, data) => (await nodeApiClient.post(`/ncd/breast-screening-cho/${individualId}`, data)).data,
  getBreastScreeningCHO: async (individualId, screeningId) => (await nodeApiClient.get(`/ncd/breast-screening-cho/${individualId}/${screeningId}`)).data,
  submitCervicalScreening: async (individualId, screeningId, data) => (await nodeApiClient.post(`/ncd/cervical-screening/${individualId}/${screeningId}`, data)).data,
  getCervicalScreening: async (individualId, screeningId) => (await nodeApiClient.get(`/ncd/cervical-screening/${individualId}/${screeningId}`)).data,
  submitCervicalScreeningCHO: async (individualId, data) => (await nodeApiClient.post(`/ncd/cervical-screening-cho/${individualId}`, data)).data,
  getCervicalScreeningCHO: async (individualId, screeningId) => (await nodeApiClient.get(`/ncd/cervical-screening-cho/${individualId}/${screeningId}`)).data,

  getPrescription: async (individualId) => (await nodeApiClient.get(`/ncd/prescription-details/${individualId}`)).data,

  getFamilyInfo: async (individualId) => (await nodeApiClient.get(`/ncd/family-registration/${individualId}`)).data,

  getFacilityType: (chart = {}) => {
    if (chart?.catchmentType || chart?.catchment_type) {
      return chart.catchmentType || chart.catchment_type;
    }
    const userStr = localStorage.getItem("NCD_loggedinUserdetails");
    let userObj = {};
    try { userObj = JSON.parse(userStr || '{}'); } catch (e) {}

    const facilityType = userObj?.facilityType;
    let type = "";
    if (facilityType === 'PHC') type = "7004";
    if (facilityType === 'TALUKA') type = "7003";
    if (facilityType === 'CHC' || facilityType === 'DH') type = "7002";
    if (!type) type = "7005";
    return type;
  },

  getDashboardData: async (input = {}) => {
    const catchmentType = ncdAPI.getFacilityType(input);

    const section = input.section || 'ncd_program_analysis';
    const view = input.view || 'reporting';
    const chart = input.chart || 'mo_dashboard_data';

    const params = new URLSearchParams();
    params.append('section', section);
    params.append('view', view);
    params.append('chart', chart);
    params.append('program', 'all');
    params.append('hwc', 'all');
    params.append('catchment_type', catchmentType);
    params.append('urbanphc', '');
    params.append('disease', '');

    if (input.returnType || input.return_type) {
      params.append('return_type', input.returnType || input.return_type);
    }

    const locType = input.locationType || input.location_type;
    if (locType) {
      params.append('location_type', locType);
    }

    const locFacilityId = input.locationTypeId || input.location_facility_id;
    if ((locType === 'DH' || locType === 'CHC') && locFacilityId) {
      params.append('location_facility_id', locFacilityId);
    }

    params.append('location_state_id', input.stateId || input.location_state_id || 'all');
    params.append('location_district_id', input.districtId || input.location_district_id || 'all');
    params.append('location_taluka_id', input.talukaId || input.location_taluka_id || 'all');
    params.append('location_phc_id', input.phcId || input.location_phc_id || 'all');
    params.append('location_subcenter_id', input.subcenterId || input.location_subcenter_id || 'all');
    params.append('location_village_id', input.villageId || input.location_village_id || 'all');
    params.append('age_range', 'all');
    params.append('gender', 'all');
    params.append('cbac', 'all');
    params.append('facility', input.facility || '');
    params.append('indicator', input.indicator || '');
    params.append('level', input.level || '');

    return (await nodeApiClient.get(`/ncd/dashboard?${params.toString()}`)).data;
  },

  getFacilityDetails: async (facilityTypeId, facilityId) => (await nodeApiClient.get(`/ncd/facility-details/${facilityTypeId}/${facilityId}`)).data,
  getStateChildren: async (locationId) => (await nodeApiClient.get(`/ncd/state-children/${locationId}`)).data,
  getDistrictChildren: async (locationId) => (await nodeApiClient.get(`/ncd/district-children/${locationId}`)).data,
  getTalukaChildren: async (locationId) => (await nodeApiClient.get(`/ncd/taluka-children/${locationId}`)).data,
  getPHCChildren: async (locationId) => (await nodeApiClient.get(`/ncd/phc-children/${locationId}`)).data,

  // MO APIs
  submitHTNDBFollowup: async (formType,individualId, data) => (await nodeApiClient.post(`/ncd/submit-htn-db-followup/${formType}/${individualId}`, data)).data,
  getTreatmentHistory: async (formType, individualId, screeningId) => (await nodeApiClient.get(`/ncd/treatment-history/${formType}/${individualId}/${screeningId}`)).data,
  getTreatmentHistoryDB: async (formType, individualId, screeningId) => (await nodeApiClient.get(`/ncd/treatment-history-db/${formType}/${individualId}/${screeningId}`)).data,
  actionDetails: async (formType, individualId, screeningId) => (await nodeApiClient.get(`/ncd/action-details/${formType}/${individualId}/${screeningId}`)).data,
  submitInitialAssessmentVitals: async (individualId, data) => (await nodeApiClient.post(`/ncd/initial-assessment/vitals/${individualId}`, data)).data,
  submitInitialAssessmentHistory: async (individualId, data) => (await nodeApiClient.post(`/ncd/initial-assessment/history/${individualId}`, data)).data,
  getInitialAssessmentHistory: async (individualId) => (await nodeApiClient.get(`/ncd/initial-assessment/history/${individualId}`)).data,
  submitInitialAssessmentSymtoms: async (individualId, data) => (await nodeApiClient.post(`/ncd/initial-assessment/symptoms/${individualId}`, data)).data,
  getInitialAssessmentSymptoms: async (individualId) => (await nodeApiClient.get(`/ncd/initial-assessment/symptoms/${individualId}`)).data,
  submitInitialAssessmentMedications: async (individualId, data) => (await nodeApiClient.post(`/ncd/initial-assessment/current-medication/${individualId}`, data)).data,
  getInitialAssessmentMedications: async (individualId) => (await nodeApiClient.get(`/ncd/initial-assessment/current-medication/${individualId}`)).data,
  getInitialAssessmentMedicines: async (searchText) => (await nodeApiClient.get(`/ncd/initial-assessment/medicines/${searchText}`)).data,
  submitInitialAssessmentPhysicalExam: async (individualId, data) => (await nodeApiClient.post(`/ncd/initial-assessment/physical-examination/${individualId}`, data)).data,
  getInitialAssessmentPhysicalExam: async (individualId) => (await nodeApiClient.get(`/ncd/initial-assessment/physical-examination/${individualId}`)).data,

  submitOralFollowup: async (individualId, screeningId, data) => (await nodeApiClient.post(`/ncd/oral-screening-followup/${individualId}/${screeningId}`, data)).data,
  submitOralRefer: async (individualId, screeningId, data) => (await nodeApiClient.post(`/ncd/oral-screening-refer/${individualId}/${screeningId}`, data)).data,

  submitBreastFollowup: async (individualId, screeningId, data) => (await nodeApiClient.post(`/ncd/breast-screening-followup/${individualId}/${screeningId}`, data)).data,
  submitBreastRefer: async (individualId, screeningId, data) => (await nodeApiClient.post(`/ncd/breast-screening-refer/${individualId}/${screeningId}`, data)).data,

  submitCervicalFollowup: async (individualId, screeningId, data) => (await nodeApiClient.post(`/ncd/cervical-screening-followup/${individualId}/${screeningId}`, data)).data,
  submitCervicalRefer: async (individualId, screeningId, data) => (await nodeApiClient.post(`/ncd/cervical-screening-refer/${individualId}/${screeningId}`, data)).data,

  updateSreeningStatus: async (formType, individualId, screeningId, data) => (await nodeApiClient.post(`/ncd/screening-status/${formType}/${individualId}/${screeningId}`, data)).data,

  getScreeningFollowup: async (conditionId, individualId, screeningId) => (await nodeApiClient.get(`/ncd/screening-followup/${conditionId}/${individualId}/${screeningId}`)).data,
  getScreeningTreatment: async (conditionId, individualId, screeningId) => (await nodeApiClient.get(`/ncd/screening-treatment/${conditionId}/${individualId}/${screeningId}`)).data,
  submitScreeningTreatment: async (conditionId, individualId, screeningId, data) => (await nodeApiClient.post(`/ncd/screening-treatment/${conditionId}/${individualId}/${screeningId}`, data)).data,
  submitScreeningDiagnosis: async (conditionId, individualId, screeningId, data) => (await nodeApiClient.post(`/ncd/screening-diagnosis/${conditionId}/${individualId}/${screeningId}`, data)).data,
  getScreeningDiagnosis: async (conditionId, individualId, screeningId) => (await nodeApiClient.get(`/ncd/screening-diagnosis/${conditionId}/${individualId}/${screeningId}`)).data,
  
  getInAssInvestigation: async (individualId) => (await nodeApiClient.get(`/ncd/investigation/${individualId}`)).data,
  getInAssOrderedLabTests: async (individualId) => (await nodeApiClient.get(`/ncd/investigation/view-ordered-lab-tests/${individualId}`)).data,
  submitInAssLabTestResults: async (individualId, data) => (await nodeApiClient.post(`/ncd/investigation/save-lab-test-results/${individualId}`, data)).data,
  submitInAssLabTestFile: async (individualId, labTestId, data) => (await nodeApiClient.post(`/ncd/investigation/attach-lab-test-file/${individualId}/${labTestId}`, data)).data,

  fetchGeneralSymptomsSearch: async (searchText) => (await nodeApiClient.get(`/ncd/general-screening/symptoms-search/${searchText}`)).data,
  submitGeneralScreening: async (individualId, screeningId, data) => (await nodeApiClient.post(`/ncd/general-screening/${individualId}/${screeningId}`, data)).data,
  fetchGeneralScreening: async (individualId, screeningId) => (await nodeApiClient.get(`/ncd/general-screening/${individualId}/${screeningId}`)).data,
  addExamination: async (conditionId, individualId, data) => (await nodeApiClient.post(`/ncd/condition/${conditionId}/individual/${individualId}/program/1/addExamination`, data)).data,
};